export class IssueReport {
    id?: string
    equipmentId = ''
    dateTimeOfIssue: Date | null = new Date()
    operatorName: number = 0
    job = ''
    hoursMileage = ''

    systemAffected = ''

    failureTypes: string[] = []
    failureTypeOther = ''

    conditionNow = ''

    safetyStatus = ''

    quickObservations: string[] = []

    actionsTaken: string[] = []

    severity = ''

    shortDescription = ''

    suggestedMechanicHrRef: number | null = null

    images: any[] = []
    videos: any[] = []
    documents: any[] = []

    existingImageUrls: string[] = []
}
